import {GET_GENERATED_INVOICES} from "./ActionType";

export default function generatedInvoices(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case GET_GENERATED_INVOICES:
      return (state = payload);
      
    default:
      return state;
  }
}